import React from 'react';

export const Hero4 = ({
  width = 0,
  height = 0,
}: {
  width: number;
  height: number;
}) => (
  <svg width={width} height={height} viewBox="0 0 762 1121" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_12_706" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="762" height="1121">
      <path d="M762 0H0V1121H762V0Z" fill="#FF6170" />
    </mask>
    <g mask="url(#mask0_12_706)">
      <path d="M762 0H0V1121H762V0Z" fill="#F3DA6C" />
      <path d="M402.847 83H997.847V1063H402.847V83Z" fill="#D2B414" />
      <path d="M452.847 -27V617V1261" stroke="#191919" strokeWidth="2" />
      <path d="M502.847 -27V617V1261" stroke="#191919" strokeWidth="2" />
      <path d="M552.847 -27V617V1261" stroke="#191919" strokeWidth="2" />
      <ellipse cx="1022.85" cy="575.5" rx="310" ry="313.5" fill="#695F0F" />
      <ellipse cx="-215.153" cy="575.5" rx="310" ry="313.5" fill="#D2B414" />
      <path d="M403.347 262C362.703 262 322.457 270.109 284.907 285.864C247.356 301.619 213.237 324.711 184.498 353.822C155.758 382.933 132.96 417.493 117.406 455.529C101.853 493.564 93.8472 534.331 93.8472 575.5C93.8472 616.669 101.853 657.436 117.406 695.471C132.96 733.507 155.758 768.067 184.498 797.178C213.237 826.289 247.356 849.381 284.907 865.136C322.457 880.891 362.703 889 403.347 889L403.347 575.5V262Z" fill="#D2B414" />
      <path d="M403.347 889C485.432 889 564.154 855.971 622.197 797.178C680.239 738.385 712.847 658.645 712.847 575.5C712.847 492.355 680.239 412.615 622.197 353.822C564.154 295.029 485.432 262 403.347 262L403.347 575.5V889Z" fill="#695F0F" />
    </g>
    <mask id="mask1_12_706" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="93" y="262" width="311" height="627">
      <path d="M403.347 262C321.263 262 242.54 295.029 184.498 353.822C126.455 412.615 93.8472 492.355 93.8472 575.5C93.8472 658.645 126.455 738.385 184.498 797.178C242.54 855.971 321.263 889 403.347 889L403.347 575.5V262Z" fill="#695F0F" />
    </mask>
    <g mask="url(#mask1_12_706)">
      <circle cx="400.847" cy="574" r="49" stroke="#191919" strokeWidth="2" />
      <circle cx="400.847" cy="574" r="99" stroke="#191919" strokeWidth="2" />
      <circle cx="400.847" cy="576" r="149" stroke="#191919" strokeWidth="2" />
      <circle cx="400.847" cy="576" r="199" stroke="#191919" strokeWidth="2" />
      <circle cx="400.847" cy="574" r="249" stroke="#191919" strokeWidth="2" />
    </g>
  </svg>
);

export default Hero4;
